import { QuestionCircleOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import styled from '@emotion/styled';
import { Modal, ModalProps, Space, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';
import StatusButton from 'components/StatusButton';
import React, { useEffect, useMemo } from 'react';
import CaptchaInput from 'views/Startups/components/CaptchaInput';
import useSMSVerify from './useSMSVerify';
import { useTransAppProductName } from 'hooks/useTrans';

type VerifyProps = ReturnType<typeof useSMSVerify>;

export interface SMSVerifyModalProps extends Omit<ModalProps, 'children'> {
  children?:
    | React.ReactNode
    | ((props: { verifyProps: ReturnType<typeof useSMSVerify> }) => React.ReactNode);
  verifyProps: VerifyProps;
  onSubmit?: (value: string) => Promise<boolean>;
}

const Mt = styled.div`
  margin-top: 2px;
  margin-bottom: 16px;
`;

const BlockButton = styled(StatusButton)`
  display: block;
  width: 100%;
  margin: 10px 0;
`;
const SMSVerifyModal = (props: SMSVerifyModalProps) => {
  const { children, verifyProps, onSubmit, ...otherProps } = props;
  const {
    captchaProps,
    value,
    onChange,
    captchaProps: { times },
    // payload,
    encodedPhone,
  } = verifyProps;
  const { t } = useTranslate();
  const appProductNameT = useTransAppProductName();

  const content = useMemo(() => {
    if (typeof children === 'function') {
      return children({ verifyProps });
    }
    return (
      <>
        <h6
          className={css`
            font-size: 18px;
            margin: 10px 0;
          `}
        >
          {t('modals.身份验证')}
        </h6>
        <div
          className={css`
            line-height: 1.2;
            margin-bottom: 10px;
          `}
        >
          <div>{t('modals.正在修改登录手机号，请先完成身份认证。')}</div>
          {times > 0 && (
            <div>
              {t('modals.验证码已发送至：')} {encodedPhone}{' '}
            </div>
          )}
        </div>
        <div>
          <CaptchaInput {...captchaProps} value={value} onChange={onChange} />
        </div>
        <Mt>
          <Tooltip title={appProductNameT('modals.findAccountNotSupportTips')}>
            <Space align="center">
              <span>{t('modals.手机号已停用')}</span>
              <QuestionCircleOutlined size={8} />
            </Space>
          </Tooltip>
        </Mt>
        <BlockButton
          type="primary"
          disabled={!value}
          onClick={
            onSubmit
              ? () => {
                  return onSubmit(value);
                }
              : undefined
          }
        >
          {t('modals.下一步')}
        </BlockButton>
        {children}
      </>
    );
  }, [
    t,
    captchaProps,
    children,
    encodedPhone,
    onChange,
    onSubmit,
    times,
    value,
    verifyProps,
    appProductNameT,
  ]);
  useEffect(() => {
    if (!otherProps.visible) {
      onChange('');
    }
  }, [onChange, otherProps.visible]);
  return (
    <Modal footer={null} {...otherProps}>
      {content}
    </Modal>
  );
};
export default SMSVerifyModal;
